import { IconButton } from 'component/Button'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { ui } from 'store/home/ui/HomeUiStore'
import css from './DropdownMenu.module.scss'

type Props<O> = {
  title?: string
  options: ReadonlyArray<O>
  render?: (option: O) => ReactElement
  onSelect: (options: O) => void
  onClose: () => void
  style?: React.CSSProperties
}

export const DropdownMenu = observer(<O, >(props: Props<O>) => {
  const { title, options, render, onSelect, onClose, style } = props
  const { small } = ui.window

  const onClick = useLatestCallback((option: O) => {
    onClose()
    onSelect(option)
  })

  return (
    <Vertical className={css.popover} style={style}>
      {small && title && (
        <Space
          className={css.header}
          gap={12}
          pad={[0, 0]}
          height={40}
          opposite
        >
          <Typo size={14} medium upper>
            {title}
          </Typo>
          <IconButton small action={onClose}>
            <Icon name="close" size={20} />
          </IconButton>
        </Space>
      )}
      <Vertical className={css.scroll} pad={[8, 0]}>
        {options.map((option, index) => (
          <Space
            key={index}
            className={css.option}
            onClick={() => onClick(option)}
          >
            {render && render(option)}
          </Space>
        ))}
      </Vertical>
    </Vertical>
  )
})
